import { render, staticRenderFns } from "./TeachingMore.vue?vue&type=template&id=b127e152&scoped=true&"
import script from "./TeachingMore.vue?vue&type=script&lang=js&"
export * from "./TeachingMore.vue?vue&type=script&lang=js&"
import style0 from "./TeachingMore.vue?vue&type=style&index=0&id=b127e152&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b127e152",
  null
  
)

export default component.exports